import { render, staticRenderFns } from "./AddOrderNote.vue?vue&type=template&id=5ce9b922&scoped=true&"
import script from "./AddOrderNote.vue?vue&type=script&lang=js&"
export * from "./AddOrderNote.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderNote.vue?vue&type=style&index=0&id=5ce9b922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9b922",
  null
  
)

export default component.exports